import React, {useEffect, useState} from 'react';
import {FilterYearTranslation} from '../../typing/translations';
import {FilterItem} from '../../typing/used-inventory';
import {FilterCheckBox} from '../filter-checkbox';
import FilterContentLabel from '../filter-content-label';
import LabelWithStock from '../filter-label-stock';
import {StyledFilterYearContainer, StyledYearCheckboxContainer} from './styles';

interface FilterYearProps {
  years?: FilterItem[];
  translation: FilterYearTranslation;
  onHandleYearSelection: (item: FilterItem) => void;
  onHandleAllSelection: (items: FilterItem[], isChecked: boolean) => void;
  isMobile: boolean;
}
const FilterYear: React.FC<FilterYearProps> = ({
  years,
  translation,
  onHandleYearSelection,
  onHandleAllSelection,
  isMobile,
}) => {
  const [hideOptions, setHideOptions] = useState(false);
  const [allSelect, setAllSelect] = useState(false);
  const filteredYears = years?.filter(item => item.isChecked);
  const [selectedYears, setSelectedYears] = useState(filteredYears);

  const onHandleClickAll = () => {
    setAllSelect(!allSelect);
    onHandleAllSelection(years || [], !allSelect);
  };

  const onHandleItemClick = (year: FilterItem) => {
    if (allSelect && year.isChecked) setAllSelect(false);
    onHandleYearSelection(year);
  };

  useEffect(() => {
    setSelectedYears(years?.filter(item => item.isChecked));
  }, [years]);

  useEffect(() => {
    if (selectedYears?.length !== years?.length) {
      setAllSelect(false);
    }
  }, [selectedYears]);

  return (
    <StyledFilterYearContainer className="filter-model_container">
      <FilterContentLabel
        label={translation.label}
        hideOptions={hideOptions}
        setHideOptions={setHideOptions}
        isMobile={isMobile}
      />
      {(hideOptions && isMobile) || !isMobile ? (
        <StyledYearCheckboxContainer className="filter-models_models">
          <div className="filter-year_select-all">
            <FilterCheckBox
              key={'all'}
              label={'Select All'}
              value={'all'}
              onClick={onHandleClickAll}
              checked={allSelect}
            />
          </div>
          {years?.map((year: FilterItem) => (
            <FilterCheckBox
              key={year.key}
              label={
                <LabelWithStock label={year.value} stock={year.stock || 0} />
              }
              value={year.key}
              onClick={onHandleItemClick.bind(null, year)}
              checked={year.isChecked}
              isDisabled={
                typeof year.stock !== 'undefined' && year?.stock <= 0
                  ? true
                  : false
              }
            />
          ))}
        </StyledYearCheckboxContainer>
      ) : null}
    </StyledFilterYearContainer>
  );
};

export default FilterYear;
